var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.9062,
    cy: 32.3672,
    r: 32,
    fill: "#E6F4FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7259 18.2676H36.3727C35.1141 18.2676 34.0938 19.2879 34.0938 20.5466V28.8997C34.0938 30.1584 35.1141 31.1787 36.3727 31.1787H44.7259C45.9846 31.1787 47.0049 30.1584 47.0049 28.8997V20.5466C47.0049 19.2879 45.9846 18.2676 44.7259 18.2676Z",
    fill: "#2995DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4369 18.2676H21.0837C19.825 18.2676 18.8047 19.2879 18.8047 20.5466V28.8997C18.8047 30.1584 19.825 31.1787 21.0837 31.1787H29.4369C30.6955 31.1787 31.7158 30.1584 31.7158 28.8997V20.5466C31.7158 19.2879 30.6955 18.2676 29.4369 18.2676Z",
    fill: "#2995DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7259 33.5547H36.3727C35.1141 33.5547 34.0938 34.575 34.0938 35.8337V44.1869C34.0938 45.4455 35.1141 46.4658 36.3727 46.4658H44.7259C45.9846 46.4658 47.0049 45.4455 47.0049 44.1869V35.8337C47.0049 34.575 45.9846 33.5547 44.7259 33.5547Z",
    fill: "#2995DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4369 33.5547H21.0837C19.825 33.5547 18.8047 34.575 18.8047 35.8337V44.1869C18.8047 45.4455 19.825 46.4658 21.0837 46.4658H29.4369C30.6955 46.4658 31.7158 45.4455 31.7158 44.1869V35.8337C31.7158 34.575 30.6955 33.5547 29.4369 33.5547Z",
    fill: "#2995DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllQuotes);
export default __webpack_public_path__ + "static/media/All-Quotes.c3379c0e41b47e90f79af274e02edec5.svg";
export { ForwardRef as ReactComponent };